// ABOUTME: Axios wrapper for /api/v1/me; the signed-in user's preferences and default portfolio
// ABOUTME: Server-side validation enforces portfolio ownership; the client just calls the endpoints

import type { ApiSuccessResponse } from '@alpha-finder/contracts/envelope';
import type { MePreferences, UserPreferences } from '@alpha-finder/contracts/me-preferences';
import { apiClient } from './client';

export const meApi = {
  async getPreferences(): Promise<MePreferences> {
    const res = await apiClient.get<ApiSuccessResponse<MePreferences>>('/me/preferences');
    return res.data.data;
  },

  async patchPreferences(partial: Partial<UserPreferences>): Promise<void> {
    await apiClient.patch('/me/preferences', partial);
  },

  async putPreferences(full: UserPreferences): Promise<void> {
    await apiClient.put('/me/preferences', full);
  },

  async setDefaultPortfolio(portfolioId: string | null): Promise<void> {
    await apiClient.put<ApiSuccessResponse<{ defaultPortfolioId: string | null }>>(
      '/me/preferences/default-portfolio',
      { portfolioId }
    );
  },
};
